module.exports = __webpack_public_path__ + "img/solution28.505d1db7.png";